import { get, has, head, uniqueId, compact, isUndefined } from 'lodash-es'
import { getDate } from '@/js/helper/date-helper.js'
import { typo3LinkUrl } from '@/js/helper/links-helper.js'

import API_CONSTANTS from './api-constants'

export const getAllRelations = relationships =>
  Object.values(relationships).reduce((acc, value) => {
    return [...acc, ...getDataArray(get(value, API_CONSTANTS.DATA, []))]
  }, [])

/* Buttons / CTAs */
export const getCtas = relationships =>
  getRelationshipByType({ relationships, type: API_CONSTANTS.CTA.KEY })

export const getNormalizedCtaAttributes = cta => ({
  text: get(cta, [API_CONSTANTS.ATTRIBUTES, API_CONSTANTS.CTA.TEXT], ''),
  link: get(cta, [API_CONSTANTS.ATTRIBUTES, API_CONSTANTS.CTA.LINK], ''),
  type: get(cta, [API_CONSTANTS.ATTRIBUTES, API_CONSTANTS.CTA.TYPE], ''),
  alignment: get(cta, [API_CONSTANTS.ATTRIBUTES, API_CONSTANTS.CTA.ALIGNMENT], ''),
})

/* Images */
export const getImages = relationships =>
  getRelationshipByType({ relationships, type: API_CONSTANTS.IMAGE.KEY })

export const getFirstImage = relationships => head(getImages(relationships))

export const getNormalizedImageAttributesFromElement = imageElement =>
  getNormalizedImageAttributes(get(imageElement, API_CONSTANTS.ATTRIBUTES))

/*
!!TODO: Must be reviewed after the MVP has been introduced.
!!This file should be refactored if necessary.
*----------------------------------------------------------*
!!author: Christopher Bomm
!! ist keine relationship, kommt also in den links-helper
!! get(data.links… geht kaputt wenn keine links da drin sind. das linmks muss mit in den Pfad!
*/
export const getNormalizedPageControlAttributes = data => ({
  prev: get(data.links, API_CONSTANTS.LINK.PAGE_PREV),
  next: get(data.links, API_CONSTANTS.LINK.PAGE_NEXT),
  list: get(data.links, API_CONSTANTS.LINK.PAGE_LIST),
})

export const getNormalizedImageAttributes = attributes => ({
  src: typo3LinkUrl(get(attributes, API_CONSTANTS.IMAGE.SRC, '')),
  title: get(attributes, API_CONSTANTS.IMAGE.TITLE, ''),
  alt: get(attributes, API_CONSTANTS.IMAGE.ALT, ''),
  caption: get(attributes, API_CONSTANTS.IMAGE.CAPTION, ''),
  link: get(attributes, API_CONSTANTS.IMAGE.LINK, ''),
  type: get(attributes, API_CONSTANTS.TYPE, ''),
})

/*
 !!TODO: Must be reviewed after the MVP has been introduced.
 !!This file should be refactored if necessary.
 *----------------------------------------------------------*
 !!author: Christopher Bomm
*/
export const getCategoryTitle = categories =>
  categories
    .map(category => {
      const pageUrl = get(category.attributes, API_CONSTANTS.PAGEURL)
      if (!pageUrl) {
        return false
      }

      return {
        title: get(category.attributes, API_CONSTANTS.ATTRIBUTE.TITLE),
        url: get(category.attributes, API_CONSTANTS.URL),
        pageUrl: get(category.attributes, API_CONSTANTS.PAGEURL),
        current: get(category.attributes, API_CONSTANTS.CURRENT, false),
      }
    })
    .filter(Boolean)

export const getCurrentCategory = current =>
  compact(
    Object.values(current).map(value =>
      value.current
        ? {
            title: value.title,
            url: value.url,
            pageUrl: value.pageUrl,
          }
        : '',
    ),
  )

/*
!!TODO: Must be reviewed after the MVP has been introduced.
!!This file should be refactored if necessary.
*----------------------------------------------------------*
!!author: Christopher Bomm
*/
export const getNormalizedNewsAttributes = news => ({
  id: news.id,
  category: getCategoryTitle(
    get(news.relationships, [API_CONSTANTS.NEWS.CATEGORY, API_CONSTANTS.DATA], []),
  ),
  image: head(get(news.relationships, [API_CONSTANTS.IMAGE.KEY, API_CONSTANTS.DATA], [])),
  link: get(news.links, API_CONSTANTS.LINK.PAGE_ITEM),
  brand: get(news.attributes, API_CONSTANTS.BRAND.TYPE),
  header: get(news.attributes, API_CONSTANTS.ATTRIBUTE.HEADER),
  teaser: get(news.attributes, API_CONSTANTS.ATTRIBUTE.TEASER),
  read: get(news.attributes, API_CONSTANTS.ATTRIBUTE.READ),
  date: getDate(get(news.attributes, API_CONSTANTS.ATTRIBUTE.DATE)),
})

export const getDataArray = data => (Array.isArray(data) ? data : [data])

export const getProductsRelationship = relationships =>
  getRelationshipByType({ relationships, type: API_CONSTANTS.PRODUCTS.TYPE })

export const getCategories = categories =>
  getCategoryTitle(get(categories, [API_CONSTANTS.NAVIGATION.CATEGORIES, API_CONSTANTS.DATA], []))

export const getProductRelationship = relationships =>
  getRelationshipByType({ relationships, type: API_CONSTANTS.AIMEOS.TYPE.PRODUCT })

export const getCustomerGroupRelationship = relationships =>
  getRelationshipByType({ relationships, type: API_CONSTANTS.AIMEOS.TYPE.CUSTOMER_GROUP })

export const getRelationshipByType = ({ relationships, type }) =>
  getDataArray(get(relationships, [type, API_CONSTANTS.DATA], []))

export const getRelatedIncludes = ({ relationships, included, type, itemType, itemListType }) => {
  // ToDo: include more position attributes or use another way to infer the correct attribute (depends on the type of the father item)
  const itemIdsToPosition = getRelationshipByType({ relationships, type }).reduce((acc, rel) => {
    const listType = get(rel, [
      API_CONSTANTS.AIMEOS.PRODUCTS.RELATIONSHIP.ATTRIBUTES,
      API_CONSTANTS.AIMEOS.PRODUCTS.RELATIONSHIP.ATTRIBUTE.TYPE,
    ])

    if (itemListType && itemListType !== listType) {
      return acc
    }

    const config = get(rel, [
      API_CONSTANTS.AIMEOS.PRODUCTS.RELATIONSHIP.ATTRIBUTES,
      API_CONSTANTS.AIMEOS.PRODUCTS.RELATIONSHIP.ATTRIBUTE.CONFIG,
    ])
    const productPosition = get(rel, [
      API_CONSTANTS.AIMEOS.PRODUCTS.RELATIONSHIP.ATTRIBUTES,
      API_CONSTANTS.AIMEOS.PRODUCTS.RELATIONSHIP.ATTRIBUTE.POSITION,
    ])
    const position = isUndefined(productPosition)
      ? get(rel, [
          API_CONSTANTS.AIMEOS.PRODUCTS.RELATIONSHIP.ATTRIBUTES,
          API_CONSTANTS.AIMEOS.ATTRIBUTE.RELATIONSHIP.POSITION,
        ])
      : productPosition
    acc[get(rel, API_CONSTANTS.ID)] = { position, config }
    return acc
  }, {})

  const includedArray = Array.isArray(included)
    ? included
    : has(included, itemType || type)
    ? Array.isArray(get(included, itemType || type, []))
      ? get(included, itemType || type, [])
      : has(get(included, itemType || type, {}), API_CONSTANTS.ID)
      ? [get(included, itemType || type, [])]
      : Object.values(get(included, itemType || type, {}))
    : [included]
  return includedArray
    .filter(
      include =>
        get(include, API_CONSTANTS.TYPE) === (itemType || type) &&
        has(itemIdsToPosition, get(include, API_CONSTANTS.ID)),
    )
    .map(include => {
      const { position, config } = get(itemIdsToPosition, include[API_CONSTANTS.ID])
      if (!isUndefined(position)) {
        include[API_CONSTANTS.ATTRIBUTES][
          API_CONSTANTS.AIMEOS.PRODUCTS.RELATIONSHIP.ATTRIBUTE.POSITION
        ] = position
      }
      if (!isUndefined(config)) {
        include[API_CONSTANTS.ATTRIBUTES][
          API_CONSTANTS.AIMEOS.PRODUCTS.RELATIONSHIP.ATTRIBUTE.CONFIG
        ] = config
      }
      return include
    })
}

export const generateUniqueId = uniqueId('unqiue_')
